import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  LoadingController,
  AlertController,
  ToastController,
  ModalController
} from "ionic-angular";
import { Http } from "@angular/http";
import * as papa from "papaparse";

import { ListaImpressaoPage } from "../lista-impressao/lista-impressao";

import config from "../../config/config";
/**
 * Generated class for the ListagemEventoPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: "page-listagem-evento",
  templateUrl: "listagem-evento.html"
})
export class ListagemEventoPage {
  usuarios: any;
  autorizou:any;
  items: any = [];
  numero = 0;
  pes = 1;
  foto = "";
  consulta = "";
  confirmados: any;
  con = 1;
  headerRow: any;
  http: any;
  csvData: any[];
  numeroCarro: any;
  numeroOnibusPV: any;
  numeroOnibusF: any;
  constructor(
    public navCtrl: NavController,
    private _http: Http,
    public loadingCtrl: LoadingController,
    private alertCtrl: AlertController,
    private modal: ModalController,
    private toastCtrl: ToastController,

    public navParams: NavParams
  ) { }
  ionViewDidLoad() {
    this.todos();
    this.autorizou = this.navParams.get("usuario");
  }
  todos() {
    this.items = [];
    this.confirmados = [];
    let loading = this.loadingCtrl.create({
      content: "Aguarde"
    });
    loading.present();
    this._http
      .get(config.urlAPI + "evento/inscritos", {})
      .map(res => res.json())
      .toPromise()
      .then(res => {
        for (let g = 0; g < res.length; g++) {
          if (g == 0) {
            this.numero = parseInt(res[g].total)
          }
          if (res[g].usuario) {

            if (res[g].usuario.dados.foto == null) {
              res[g].usuario.dados.foto = "public/perfildefault.jpg";
            }
          }
          this.items.push(res[g]);


          if (res[g].presenca != 0) {
            this.confirmados.push(res[g]);

          }

          // this.numero = res[g].total;

        }
        this.usuarios = this.items;

        loading.dismiss();
      })
      .catch(error => {
        loading.dismiss();
      });
  }
  initializeItems() {
    if (this.con == 1) {
      this.items = [];

      for (var i = 0; i < this.usuarios.length; ++i) {
        var it = this.usuarios[i];
        this.items.push(it);
      }
    } else {
      this.items = [];

      for (var g = 0; g < this.confirmados.length; ++g) {
        var co = this.confirmados[g];
        this.items.push(co);
      }
    }
  }

  getItems(ev: any) {
    this.initializeItems();
    const val = ev;
    this.consulta = val;
    // if the value is an empty string don't filter the items
    if (this.pes == 1) {
      if (val && val.trim() != "") {
        this.items = this.items.filter(item => {
          return (
            item.usuario.nome
              .toString()
              .toLowerCase()
              .indexOf(val.toLowerCase()) > -1
          );
        });
      } else {
        this.initializeItems();
      }
    }
    if (this.pes == 2) {
      if (val && val.trim() != "") {
        this.items = this.items.filter(item => {
          return (
            item.usuario.siape
              .toString()
              .toLowerCase()
              .indexOf(val.toLowerCase()) > -1
          );
        });
      } else {
        this.initializeItems();
      }
    }
    if (this.pes == 3) {
      if (val && val.trim() != "") {
        this.items = this.items.filter(item => {
          return (
            item.codigo
              .toString()
              .toLowerCase()
              .indexOf(val.toLowerCase()) > -1
          );
        });
      } else {
        this.initializeItems();
      }
    }
    ev = "";
  }
  filtrofunc(pes) { }
  comparceu(env) {
    env.autorizou = this.autorizou.id;

    let alert = this.alertCtrl.create({
      title: "Comparecer",
      subTitle: "Confirma entrada desse sindicalizado: " + env.usuario.nome + " ?",
      buttons: [
        {
          text: "Sim",
          handler: data => {
            let loading = this.loadingCtrl.create({
              content: "Aguarde"
            });
            console.log(env);
            loading.present();

            this._http
              .post(config.urlAPI + "compareceu/evento", env, {})
              .map(res => res.json())
              .toPromise()
              .then(res => {
               
                this.toastCtrl.create({
                  message: "Entrada confirmada com sucesso!",
                  duration: 3000
                }).present();
                this.ionViewDidLoad();

                
                loading.dismiss();
                console.log(res);


              })
              .catch(error => {
                this.toastCtrl.create({
                  message: "erro ao confirmar entrada",
                  duration: 3000
                }).present();
                loading.dismiss();
                console.log(error);

              });
          }
        },
        {
          text: "Não",
          handler: data => { }
        }
      ]
    });
    alert.present();
  }
  arrayRemove(arr, value) {

    return arr.filter(function (ele) {
      return ele.id != value;
    });

  }
  pesquisa(con) {
    this.con = con;
    if (this.con == 2) {
      this.items = this.confirmados;
    } else {
      this.items = this.usuarios;
    }
  }

  public readCsvData() {
    if (this.items.length > 0) {
      this.extractData();
      // console.log(this.items);
    } else {
      console.log("vazio");
    }
  }

  private extractData() {
    let teste = [];
    for (let f = 0; f < this.items.length; f++) {

      let element = {
        nome: this.items[f].usuario.nome,
        email: this.items[f].usuario.email,
        siape: this.items[f].usuario.siape,
        meioTransporte: this.items[f].meioTransporte,
        celular: this.items[f].usuario.dados.telefonePessoal,
        genero: this.items[f].usuario.dados.sexo,
        unidadeTrabalho: this.items[f].usuario.dados.unidade,
        cargo: this.items[f].usuario.dados.cargo,
        formacaoAcademica: this.items[f].usuario.dados.escolaridade,
        estado: this.items[f].usuario.dados.estado,
        cidade: this.items[f].usuario.dados.cidade,
        bairro: this.items[f].usuario.dados.bairro,
        uf: this.items[f].usuario.dados.uf,
        cep: this.items[f].usuario.dados.cep,
        rua: this.items[f].usuario.dados.rua,
        numero: this.items[f].usuario.dados.numero,
        complemento: this.items[f].usuario.dados.complemento,


      };
      var obj = Object.assign({}, element, this.items[f].informes);
      teste.push(obj);
    }
    this.downloadCSV(teste);
  }

  downloadCSV(env) {
    let csv = papa.unparse(env);

    // Dummy implementation for Desktop download purpose
    var blob = new Blob([csv]);
    var a = window.document.createElement("a");
    a.href = window.URL.createObjectURL(blob);
    a.download = "inscritos.csv";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  // private handleError(err) {
  //   console.log("something went wrong: ", err);
  // }

  trackByFn(index: any, item: any) {
    return index;
  }
  modalFoto(item) {
    const fotoModal = this.modal.create("InscritoModalPage");
    fotoModal.present();
  }
  impPage(filtro) {
    this.navCtrl.push(ListaImpressaoPage, {
      filtro: filtro
    });
  }
  buscaespecifica() {
    let loadingbusca = this.loadingCtrl.create({
      content: "Aguarde"
    });
    if (this.consulta) {
      let coluna = "";
      if (this.pes == 1) {
        coluna = "nome";
      }
      if (this.pes == 2) {
        coluna = "siape";
      }
      loadingbusca.present();

      this._http
        .get(
          config.urlAPI + "inscricoes/buscar/" + coluna + "/" + this.consulta,
          {}
        )
        .map(res => res.json())
        .toPromise()
        .then(res => {
          this.items = [];

          for (let t = 0; t < res.length; t++) {

            if (!res[t].usuario.dados) {
              continue;
            }
            if (res[t].usuario.dados.foto == null) {
              res[t].usuario.dados.foto = "/public/perfildefault.jpg";

            }
            this.items.push(res[t]);
          }
          loadingbusca.dismiss();

          // this.items = res;
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/listagem-evento/listagem-evento.ts